"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearButton = exports.Input = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../styled-components");
const Icons_1 = require("../Icons");
exports.Input = styled_components_1.styled.input `
  flex: 0 0 auto;
  width: 100%;
  background: ${({ theme }) => theme.inputBg};
  padding: 5px ${(props) => (props.clearButton ? "30px" : "10px")} 5px
    ${(props) => (props.magnifyingGlass ? "30px" : "10px")};
  box-shadow: inset 0 1px 1px #000d;
  min-height: 30px;
  min-width: ${(props) => { var _a; return (_a = props.minWidth) !== null && _a !== void 0 ? _a : "30px"; }};
  border: none;
  border-radius: ${({ theme }) => theme.radius};
  color: ${({ theme }) => theme.fg};
  &:disabled {
    opacity: 0.5;
  }
  &::-ms-clear {
    /* Hide the native IE/Edge clear button */
    visibility: hidden;
  }
  &::-ms-reveal {
    display: none;
  }
  &::-webkit-inner-spin-button {
    margin-left: 5px;
  }
`;
const FloatingButtonStyle = styled_components_1.styled.div `
  cursor: pointer;
  position: absolute;
  top: ${({ top }) => (top ? `${top}px` : "7px")};
  right: 7px;
  /* Override the font to prevent coloured emoji being used */
  font-family: "Segoe UI symbol", sans-serif;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;
const ClearButton = ({ onClick, title = "clear", top }) => (react_1.default.createElement(FloatingButtonStyle, { title: title, onClick: onClick, top: top },
    react_1.default.createElement(Icons_1.Cross, null)));
exports.ClearButton = ClearButton;
//# sourceMappingURL=Input.js.map